import { Injectable } from '@angular/core';

import { PushService } from 'rev-shared/push/PushService';

@Injectable({
	providedIn: 'root'
})
export class VideoCommentService {

	constructor(
		private PushService: PushService
	) { }

	public addRootVideoComment(comment): Promise<any> {
		return this.PushService.dispatchCommand('media:AddRootVideoComment', {
			videoId: comment.videoId,
			text: comment.text
		});
	}

	public addChildVideoComment(comment): Promise<any> {
		return this.PushService.dispatchCommand('media:AddChildVideoComment', {
			videoId: comment.videoId,
			parentCommentId: comment.parentCommentId,
			text: comment.text
		});
	}

	public removeComment(comment): Promise<any> {
		return this.PushService.dispatchCommand('media:RemoveVideoComment', {
			videoId: comment.videoId,
			commentId: comment.id,
			parentCommentId: comment.parentCommentId
		});
	}
}
